import { render, staticRenderFns } from "./deptNew.vue?vue&type=template&id=de345e2a&"
import script from "./deptNew.vue?vue&type=script&lang=js&"
export * from "./deptNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports